import React, { useState } from 'react';
import { Card, CardHeader, CardContent, CardMedia, Typography, IconButton, Menu,
         MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InfoIcon from '@mui/icons-material/Info'; 
import DescriptionIcon from '@mui/icons-material/Description';

const VereadorCard = ({ nome, partido, imagem, onMenuClick, proposicoes }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
  
    const handleMenuClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleMenuClose = () => {
      setAnchorEl(null);
    };
  
    return (
      <Card 
      role="region"
      aria-labelledby={`vereador-${nome}`} // ID único para associar com o nome
      sx={
               { width: 250,
                 height: 300,
                 padding: 1,
                 boxShadow: 5,
                 transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                 transform: "scale(1.09)", // Aumenta ligeiramente o tamanho no hover
                 boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.4)", // Aumenta a sombra no hover
                 outline: "2px solid #FFD700",
                },
                "&:focus-within": {
                outline: "2px solid #FFD700", // Adiciona uma borda dourada ao receber foco
                },  
              }
               }
               tabIndex={0} // Permite foco no Card
               >
        <CardHeader
          id={`vereador-${nome}`} // ID para conectar o atributo `aria-labelledby`
          action={
            <IconButton 
            aria-label="Mais informações do vereador"
            aria-controls={open ? "menu-opcoes" : undefined}
            aria-haspopup="true"
            onClick={handleMenuClick}>
              <MoreVertIcon />
            </IconButton>
          }
          sx={{
            padding: "1px", // Reduz o padding interno
          }}
        />
        <CardMedia
          component="img"
          image={imagem}
          alt={`Foto de ${nome}`}
          sx={{
            height: 180,
            width: "70%",
            objectFit: "cover",
            objectPosition: "center top",
            margin: "0 auto",
            borderRadius: "50%",
            border: "1px solid #FFD700",
            marginTop: "-6px",
          }}
        />
        <CardContent 
          sx={{ textAlign: "center", backgroundColor: "#FFF" }}>
          <Typography
            variant="h6"
            sx={{ fontSize: "18px",
            color: "#C9B037",
            fontWeight: "bold" }}>
            {nome}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "16px", color: "#555", fontWeight: "bold" }}>
            {partido}
          </Typography>
        </CardContent>

        <Menu
        id="menu-opcoes"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        aria-labelledby={`vereador-${nome}`}
        role="menu"
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            handleMenuClose();
          }
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {/* Opção: Biografia */}
        <MenuItem
          onClick={() => {
            onMenuClick("biografia");
            handleMenuClose();
          }}
        >
          <ListItemIcon>
            <InfoIcon fontSize="small" /> {/* Ícone para Biografia */}
          </ListItemIcon>
          <ListItemText primary="Biografia" />
        </MenuItem>

        {/* Opção: Proposituras */}
        <MenuItem
          onClick={() => {
            onMenuClick("proposicoes");
            handleMenuClose();
          }}
          disabled={!proposicoes || !proposicoes.link} // Verifica se não há link
          aria-disabled={!proposicoes || !proposicoes.link} // Adiciona atributo de acessibilidade
        >
          <ListItemIcon>
          <DescriptionIcon fontSize="small" aria-hidden="true" /> {/* Ícone não acessível */}
          </ListItemIcon>
          <ListItemText primary="Proposituras" />
        </MenuItem>
      </Menu>
    </Card>
    );
  };  

export default VereadorCard;